module.exports = __webpack_public_path__ + "img/mile2.263fdfca.webp";